import { Navigate, useSearchParams } from "react-router-dom";
import { env } from "@/config/env";

/** Legacy Stripe return URLs (/success, /cancel) forward to the report page. */
export function CheckoutSuccessRedirect() {
  const [search] = useSearchParams();
  const reportId = search.get("reportId");
  const offerId = search.get("offerId") ?? env.defaultOfferId ?? "sop-coverage";
  const sessionId = search.get("session_id");
  if (!reportId) return <Navigate to="/" replace />;
  const qs = sessionId ? `?session_id=${encodeURIComponent(sessionId)}` : "";
  return <Navigate to={`/${offerId}/preview/${reportId}${qs}`} replace />;
}

export function CheckoutCancelRedirect() {
  const [search] = useSearchParams();
  const reportId = search.get("reportId");
  const offerId = search.get("offerId") ?? env.defaultOfferId ?? "sop-coverage";
  if (!reportId) return <Navigate to="/" replace />;
  return <Navigate to={`/${offerId}/preview/${reportId}`} replace />;
}
